<template>
  <v-app id="app">
    <v-content>
      <v-fade-transition mode="out-in">
        <router-view></router-view>
      </v-fade-transition>
    </v-content>

    <footer class="site-footer">
      <div class="pr-container site-footer__inner">
        <div class="site-footer__brand">
          <img :src="require('@/assets/2023/prdays-logo-white-2023.svg')" alt="PR, Media & Sports Days University of Mostar"/>
          <p>
            Filozofski fakultet Sveučilišta u Mostaru<br>
            Matice hrvatske b. b., 88000 Mostar, BiH<br>
            <a href="mailto:prdays@ff.sum.ba">prdays@ff.sum.ba</a>
          </p>
        </div>
        <div class="site-footer__meta">
          <p>
            Copyright © {{ new Date().getFullYear() }}
            <a href="https://sumit.sum.ba/" target="_blank" rel="noopener">SUMIT</a>
          </p>
          <a href="https://sumit.sum.ba/" target="_blank" rel="noopener" aria-label="SUMIT">
            <img class="site-footer__sumit" :src="require('@/assets/img/sum-it-white-svg.svg')" alt="SUMIT"/>
          </a>
        </div>
      </div>
    </footer>
  </v-app>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style lang="scss">
.site-footer {
  padding: 48px 0 40px;
  background: #001733;
  color: rgba(255, 255, 255, .75);
  font-size: 14px;

  a {
    color: #fff !important;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  p {
    margin: 0;
    line-height: 1.7;
  }
}

.site-footer__inner {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 32px;
}

.site-footer__brand {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 24px;

  img {
    height: 64px;
  }
}

.site-footer__meta {
  display: flex;
  align-items: center;
  gap: 16px;
}

.site-footer__sumit {
  height: 44px;
  display: block;
}
</style>
